import { createContext, createElement, useContext } from "react";

import type { GraphQLProviderProps, GraphQLRequestFn } from "../types/graphql";

const GraphQLClientContext = createContext<GraphQLRequestFn | null>(null);

/**
 * shopify 쿼리 훅들이 사용하는 GraphQL fetch 함수를 앱 트리에 주입한다.
 * (Apollo의 `<ApolloProvider client={...}>` 역할)
 *
 * 패키지 exports 매핑(`./src/*.ts`)에 맞추기 위해 JSX 대신 createElement를 사용한다.
 * React 19 부터 Context 자체를 provider 로 렌더할 수 있어 `.Provider` 는 생략한다.
 */
export function GraphQLProvider({ client, children }: GraphQLProviderProps) {
  return createElement(GraphQLClientContext, { value: client }, children);
}

/** 현재 앱에 주입된 GraphQL fetch 함수를 반환한다. */
export function useGraphQLClient(): GraphQLRequestFn {
  const client = useContext(GraphQLClientContext);
  if (!client) {
    throw new Error("useGraphQLClient는 <GraphQLProvider> 내부에서만 사용할 수 있습니다.");
  }
  return client;
}
